import {useOutletContext} from "react-router-dom";

import {useDownload} from "base/file/utilities";
import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";

import {permit_view_adapter} from "permit/model";
import {PermitExtensionService} from "permitextension/service";

import {PermitExtensionForm} from "./form";
import {PermitApplicationInvoiceFormFields} from "permitapplication/presentational/form";
import {DownloadPDFButton} from "base/pdf/presentational";
import Stack from "@mui/material/Stack";

const PermitExtensionInvoiceStep = () => {
    const download = useDownload();
    const navigate = useNavigateWithReload();

    const {extension, isStepEditable} = useOutletContext();
    const {handleErrors} = useErrors();

    const handleDownload = () => {
        if (extension) {
            return PermitExtensionService.downloadInvoice(extension.id).then(
                response => {
                    return download(response)
                        .then(() => navigate("", true))
                        .catch(error => handleErrors(error));
                }
            );
        } else {
            return Promise.reject("Nenhuma factura foi selecionada.");
        }
    };

    const handleFormSubmit = updatedPermit => {
        PermitExtensionService.update(permit_view_adapter(updatedPermit))
            .then(updatedPermit => {
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    return extension ? (
        <Stack spacing={2}>
            <Stack alignItems="center">
                <DownloadPDFButton
                    handleGeneratePDF={handleDownload}
                    text="Imprimir factura"
                    color="secondary"
                    disabled={!isStepEditable}
                />
            </Stack>
            <PermitExtensionForm entity={extension} onSubmit={handleFormSubmit}>
                <PermitApplicationInvoiceFormFields disabled={!isStepEditable} />
            </PermitExtensionForm>
        </Stack>
    ) : null;
};

export default PermitExtensionInvoiceStep;
